import { gasTankModule } from './gasTankModule'

export default gasTankModule
